<template>
  <div class="Main_content_manage" v-loading="loading">
    <section class="search_btn">
      <div class="search_items">
        <el-button type="danger" @click="edit_slide_show('add')">添加</el-button>
      </div>
    </section>
    <section class="user_info_list">
      <el-table :data="tableData">
        <el-table-column prop="id" label="ID" />
        <el-table-column prop="sort" label="排序" />
        <el-table-column prop="pathType" label="名称">
          <template #default="scope">
            <div v-show="scope.row.pathType==1">公众号</div>
            <div v-show="scope.row.pathType==4">视频号主页</div>
            <div v-show="scope.row.pathType==5">视频号视频</div>
            <div v-show="scope.row.pathType==6">视频号直播</div>
            <div v-show="scope.row.pathType==7">支线问卷</div>
            <div v-show="scope.row.pathType==8">杂货铺产品详情</div>
          </template>
        </el-table-column>
        <el-table-column prop="pathContent" label="视频号ID或公众号链接" width="200"/>
        <el-table-column prop="associatedId" label="视频ID或直播文案" width="160"/>
        <el-table-column prop="image" label="图片" width="120">
          <template #default="scope">
            <img :src="scope.row.image" class="avatar">
          </template>
        </el-table-column>
        <el-table-column prop="image" label="按钮文案" width="120">
          <template #default="scope">
            {{scope.row.content?scope.row.content.split(',')[0]:''}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160"/>
        <el-table-column fixed="right" label="操作" width="200">
          <template #default="scope">
            <el-tag class="ml-2" @click="edit_slide_show('edit',scope)">编辑</el-tag>
            <el-tag class="ml-2" type="success" @click="Is_delete(scope)">删除</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <section class="pagination">
      <el-pagination :page-size="this.pageSize" :currentPage="this.pageNo" :total="this.totalCount" @current-change="Current_change" pager-count="10" background layout="prev, pager, next"></el-pagination>
    </section>

  </div>
</template>

<script>
import {Search,MessageBox} from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import global_api from "@/config/Api";
export default {
  name: 'Slide_show_setting',
  data(){
    return {
      Search:Search,    //图标
      MessageBox:MessageBox,//图标
      update_phone_dialog:false,
      options:[{
        value: 'Option1',
        label: 'Option1',
      },
        {
          value: 'Option2',
          label: 'Option2',
        }],
      pageNo:1,       //页码
      pageSize:10,      //每页数量
      totalCount:0,         //总数
      loading: false,
      tableData:[]
    }
  },
  mounted() {
    // this.global_api.test({a:1,b:2}).then((res)=>{
    //   console.log(res)
    // })
    // console.log(this.util.login())
    this.GetBannerList()
  },
  methods: {
    Current_change(number){
      this.pageNo = number
      this.GetBannerList()
    },

    GetBannerList(){       //获取首页/心愿广场轮播图列表
      let obj = {
        pageNo:this.pageNo,
        pageSize:this.pageSize,
        type:5
      }
      this.loading = true;
      global_api.GetBannerList(obj).then((res)=>{
        if(res.code!=0){
          ElMessage.error('新增/修改题目错误')
        }else{
          this.tableData = res.result
          this.loading = false;
        }
        console.log(res)
      })
    },
    Is_delete(scope){           //是否删除
      ElMessageBox.confirm(
          '是否删除?',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(() => {
        let obj = {
          bannerId:scope.row.id,
          id:1,
          type:0
        }
        global_api.DeleteBannerImage(obj).then((res)=>{
          if(res.code!=0){
            ElMessage.error('新增/修改题目错误')
          }else{
            ElMessage({
              type: 'success',
              message: '已删除',
            })
            this.GetBannerList()
          }
        })
      })
    },

    edit_slide_show(string ,scope){       //编辑 新增 题目
      if(string=='edit'){
        sessionStorage.setItem('main_item',JSON.stringify(scope.row))
      }
      this.$router.push({
        path: "/Main_content_manage/edit",
        query: { type: string, },
      });
    }

  },
}
</script>
<style scoped lang="scss">
.Main_content_manage{
  margin-top: 20px;
}
.search_btn{
  //border-radius: 5px;
}
.user_info_list{
  margin-top: 20px;
  min-width: 800px;
  .btn{
    margin-top: 5px !important;
  }
}
.pagination{
  margin-top: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.no_float{
  float: none !important;
}
.avatar{
  width: 100px;
  height: 100px;
  //height: 60px;
}

</style>
